$('.new-wrapper').click(function () {
  const currentVideo = $(this).find(".new-video").get(0);

  // Pause all other videos and show their play icons
  $('.new-video').each(function () {
    if (this !== currentVideo) {
      this.pause();
      $(this).siblings(".new-playpause").fadeIn();
    }
  });

  // Toggle play/pause on the clicked video
  if (currentVideo.paused) {
    currentVideo.play();
    $(this).find(".new-playpause").fadeOut();
  } else {
    currentVideo.pause();
    $(this).find(".new-playpause").fadeIn();
  }
});




  new Swiper(".new-video-slider", {
    navigation: {
      nextEl: ".swiper-button-next1",
      prevEl: ".swiper-button-prev1",
    },
    loop:true,
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
        1300: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        750: {
           slidesPerView: 3,
          spaceBetween: 30,
        },
        480: {
          slidesPerView: 1.8,
          spaceBetween: 30,
        },
        0: {
          slidesPerView: 1.2,
          spaceBetween: 30,
        }
      }
  });